import ScopeSub from '@/store/models/scope-subscription';
import ScopePlan from '@/store/models/scope-plan';
import byteFilter from '@/filters/byte';
const moment = window.moment;

// for legacy base
const BASE_FEATURES = [
	{
		"key": "ft_baseapp",
		"description": "Waveforms viewing and analysis, standard measurements, basic and advanced math options, basic and advanced plot options, wide range of file formats, FastFrame segmented memory, multi-language support."
	},
	{
		"key": "ft_basedecode",
		"description": "Serial decode, search and event table analysis on I2C, SPI, RS-232/422/485/UART buses."
	},
	{
		"key": "ft_baseprogrammable",
		"description": "Programmable Interface for Automation."
	},
	{
		"key": "ft_basespectrum",
		"description": "Spectrum View Basic."
	}
];
// legacy packages that will go away
const ADDON_PACKAGE_MAP = 	{
	"Multi-Scope Analysis" : "Remotely connect and acquire data directly from your oscilloscopes to view and analyze the data from all channels simultaneously on the same screen. Analyze data from up to 32 channels and 4 scopes.",
	"Jitter Measurements and Analysis": "Jitter, Eye, Amplitude, Time Measurements",
	"Low Speed Protocol Decode": "I2C, I3C, SPI, RS-232, SPMI, I2S, LJ, RJ, TDM, CAN, CAN-FD, LIN, FlexRay, SENT, 100B-T1 Automotive Ethernet, Mil-STD-1553, ARINC-429, Spacewire, USB 2.0, eUSB2, PSI5, SVID, 10 Base-T / 100 Base-TX Ethernet, MDIO, NRZ, 8b/10b, DPHY, Manchester, SDLC, One Wire (1-Wire), MIPI C-PHY CSI/DSI",
	"Power Electronics Analysis": "Advanced Power Analysis: Input Measurements, Amplitude Measurements, Timing Measurements, Switching Measurements, Output Measurements. Magnetic Analysis: Inductance Measurements, Magnetic Property Plot, Magnetic Loss Measurements, Current vs. Integral of Voltage Plot. Inverter Motor Drive Analysis: Input Analysis, Ripple Analysis, Output Analysis.",
	"Power Integrity Analysis": "Digital Power Management and Analysis: Ripple Analysis, Transient Analysis, Power Sequence Analysis, Jitter Analysis. Power Management Serial Decode and Analysis (SPMI).",
	"SpectrumView Analysis": "Performing Spectrum Analysis on an oscilloscope, with the benefits of: Any analog signal may be presented as a waveform, spectrum, or both. Time domain waveforms and spectrum are synchronized. Waveform and spectrum display may be independently adjusted. Settings are made with spectrum analyzer controls such as Center Frequency, Span, and Resolution Bandwidth (RBW).",
	"Remote Analysis for Bench Oscilloscopes": "Remotely connect and acquire real-time data directly from your bench oscilloscope. Make analysis and decode all essential protocols - I2C, SPI, RS-232/422/485/UART, CAN, CAN-FD, LIN",
};

function mapAddOns(addOns) {
	if (addOns.length === 0) {
		return;
	}
	return addOns.map(addOn => {
		return { name: addOn, description: ADDON_PACKAGE_MAP[addOn] };
	});
}

function parseDate(value) {
	if (value == null) {
		return null;
	}
	// avoid invalid date objects
	var date = new Date(value);
	return isFinite(date) ? date : null;
}

function getDisplayCode(prepaidCouponId) {
	if (!prepaidCouponId) {
		return null;
	}
	// create a display code for viewing
	return prepaidCouponId.split('_')[1];
}

function isFreePlan(plan) {
	return plan.id.includes('free');
}

function getType(sub) {
	return (sub.type === 'Prepaid' || sub.type === 'Trial' || sub.type === 'Promotion') ? sub.type : isFreePlan(sub.plan) ? 'Free' : 'Credit Card';
}

function getDisplayInterval(interval) {
	return (interval === 'monthly') ? '/ month' : '/ year';
}

function getTierName(planId) {
	// create map until sub plans and plan end point match
	const tierMap = {
		pln_scope_app_base: 'Base',
		pln_scope_app_free: 'Basic',
		pln_scope_app_starter: 'Starter',
		pln_scope_app_serialdecode: 'Professional',
		pln_scope_app_power: 'Professional',
		pln_scope_app_milgov: 'Professional',
		pln_scope_app_automotive: 'Professional',
		pln_scope_app_ultimate: 'Ultimate'
	};
	return tierMap[planId];
}

function getPlanId(plan) {
	return plan.interval === 'free' ?
		plan.id.includes('base') ? 'pln_scope_app_free_base' : plan.id + '_base'
		: plan.id;
}

function reducePlans(plans) {
	return plans.reduce(function planReducer(reducedPlans, current, index, array) {
		let tierName = current.tierName;
		let existingPlan = reducedPlans.find(plan => plan.tierName === tierName);

		if (existingPlan) {
			// if child isTierTrial make sure to flag the plan card
			if (current.isTierTrial) {
				existingPlan.isTierTrial = current.isTierTrial;
			}

		} else {
			let currentTrial;
			// let siblingPlans = [];

			// only active plans, unless current plan is inactive
			if (current.active || current.isCurrent || current.isTrial) {

				// let mappedFeatureList =

				reducedPlans.push({
					name: current.name,
					tierName: tierName,
					description: current.description,
					details: current.details,
					// siblingPlans: siblingPlans,
					interval: current.interval,
					id: current.id,
					amount: current.amount,
					paymentMethodRequired: current.paymentMethodRequired,
					active: current.active,
					displayInterval: current.displayInterval,
					hasTrial: current.hasTrial,
					isTrial: current.isTrial,
					isTierTrial: current.isTierTrial,
					isCurrent: current.isCurrent,
					isPrepaid: current.isPrepaid,
					isCurrentTier: current.isCurrentTier,
					tierHasTrial: current.tierHasTrial,
					isPro: current.isPro,
					isLegacy: current.isLegacy,
					displayName: current.displayName,
					isStarter: current.isStarter,
					isUltimate: current.isUltimate,
					isAtSubCountLimit: current.isAtSubCountLimit,
					features: current.features,
					featureList1: current.featureList1,
					featureList2: current.featureList2,
					addOns: current.addOns,
					addOnPackages: current.addOnPackages
				});
			}
		}

		return reducedPlans;
	},[]);
}

function getFullFeatureList(fullList, current, index, plans) {
	current.features.forEach(feature => {
		// add feature if not already in list add it
		if (!fullList.find(list => list.key === feature.key)) {
			fullList.push(feature);
		}
	});
	return fullList;
};

function mapFeatures(plans){
	// reverse order to get full feature list first to ensure features are displayed correctly
	const plansReversed = deepCopy(plans).reverse();
	let fullFeatureList = plansReversed.reduce(getFullFeatureList, []).filter(filterProFeatures);

	return plans.reduce(function planReducer(mappedPlans, current, index, array) {
		let currentFeaturesHash = createFeaturesHash(current.features);

		let mappedFullFeatureList = deepCopy(fullFeatureList).map((feature) => {
			feature.notSupported = !currentFeaturesHash[feature.key];
			feature.requiresPrereq = feature.key === 'ft_baseprogrammable' || feature.key === 'ft_ultmultiremote' || feature.key === 'ft_singleremote';
			return feature;
		});

		current.featureList1 = mappedFullFeatureList.slice(0, 4);
		current.featureList2 = mappedFullFeatureList.slice(4);

		mappedPlans.push(current);
		return mappedPlans;
	},[]);
}

function filterProFeatures (feature) {
	return feature.key !== 'ft_propower' && feature.key !== 'ft_proserialdecode' && feature.key !== 'ft_promilgov' && feature.key !== 'ft_proautomotive';
}

function deepCopy(obj) {
	return JSON.parse(JSON.stringify(obj));
}

function filterPlansByTier(plans, key) {
	return plans.filter(plan => plan.tierName && plan.tierName.toLowerCase() === key);
}


function formatSharing(type) {
	return {
		value: type,
		displayValue: type === 'UNLIMITED' ? 'Unlimited Contributors' : 'Contribute to business or enterprise accounts'
	};
};

function formatAccessKeys(keyLimit) {
	return {
		value: keyLimit,
		displayValue: keyLimit + ' Device Access Keys'
	};
}

function formatStorage(storage) {
	return {
		value: storage,
		displayValue: byteFilter(storage) + ' of storage'
	};
}

function formatDetails(details) {
	if (!details) {
		return;
	}
	return {
		accessKeyLimit: formatAccessKeys(details.accessKeyLimit),
		sharingType: formatSharing(details.sharingType),
		storageSizeLimit: formatStorage(details.storageSizeLimit)
	};
}

function formatPlanId(value) {
	return value.replace(/(_promotional)/i, ''); //Removed free from regex to get SubscriptionCreate page to load
}

function formatPlanName(value) {
	return value.replace(/(tekscope\s|professional\s|\spromotional)/gi, '');
}

function createFeaturesHash(array) {
	return array.reduce((map, obj) => (map[obj.key] = obj, map), {});
}

function createPlansHash(array) {
	return array.reduce((map, obj) => (map[obj.id] = obj, map), {});
}

function scopePlanFromDto(dto) {
	if (dto == null) {
		return null;
	}

	let features = dto.details && dto.details.features && dto.details.features.length && dto.details.features;
	const isLegacy = dto.id.includes('base');

	var plan = new ScopePlan();
	plan.id = formatPlanId(dto.id);
	plan.shortId = plan.id.replace('pln_scope_app_', '');
	plan.name = formatPlanName(dto.name);
	plan.details = dto.details;
	plan.interval = dto.interval;
	plan.displayInterval = getDisplayInterval(dto.interval);
	plan.addOns = dto.addOns;
	plan.currentAddOnsDisplayText = plan.addOns && plan.addOns.length && plan.addOns.join(', ');
	plan.amount = dto.amount;
	plan.paymentMethodRequired = dto.paymentMethodRequired;
	plan.customBilling = dto.customBilling ;
	plan.active = dto.active;
	plan.hasTrial = dto.hasTrial && dto.amount > 0;
	plan.tierName = getTierName(plan.id);
	plan.tierId = plan.tierName ? plan.tierName.toLowerCase() : null;
	plan.isAtSubCountLimit = dto.isAtSubCountLimit;

	// cycle through features to create a plan description for plan card
	const featureItem = features && features.find(feature => feature.key === 'ft_pro' + plan.shortId);
	plan.description = featureItem && featureItem.description;
	plan.features = features || BASE_FEATURES;

	plan.isPro = plan.tierName === 'Professional';
	plan.isStarter = plan.tierName === 'Starter';
	plan.isUltimate = plan.tierName === 'Ultimate';
	plan.isBasic = plan.tierName === 'Basic';
	plan.displayName = (plan.isPro && 'Professional - ' || '') + plan.name;

	plan.isLegacy = isLegacy;

	return plan;
}

function mapSubsToPlans(plans, subs) {

	let mappedPlans = plans.map(scopePlanFromDto);
	subs.map(sub => {
		let planToMap = mappedPlans.find(plan => plan.id === sub.plan.id);

		planToMap.isPrepaid = sub.isPrepaid && (sub.plan.id === planToMap.id);
		planToMap.isTierTrial = sub.isTrial && planToMap.tierName === sub.plan.tierName;
		planToMap.isCurrentTier = !planToMap.isTierTrial && planToMap.tierName === sub.plan.tierName;
		planToMap.isTrial = sub.isTrial && (sub.plan.id === planToMap.id);
		planToMap.isCurrent = !sub.isTrial && sub.plan.id === planToMap.id;
		planToMap.hasTrial = planToMap.hasTrial && !planToMap.isCurrent && !sub.isTrial && planToMap.amount > 0;
		planToMap.isProTrial = sub.isTrial && planToMap.tierName === 'Professional';
		planToMap.addOns = sub.plan.addOns;
		planToMap.addOnPackages = mapAddOns(sub.plan.addOns || []);
	});

	// now map features
	return mapFeatures(mappedPlans);
}

function getRenewalState(sub) {
	return (sub.isPromo && sub.transitionAtEnd) || (sub.isBasic && !sub.cancelAtPeriodEnd);
}

function isPerpetualLicense(start, end) {
	const startDate = moment(start);
	const differenceInYears = moment(end).diff(startDate, 'years');
	return differenceInYears === 100;
}

function scopeSubFromDto(dto) {
	if (dto == null) {
		return null;
	}

	let sub = new ScopeSub();
	// const type = dto.type || 'Promotion';

	sub.id = dto.id || '';
	sub.name = dto.name || 'TekScope';
	sub.description = dto.description;
	sub.plan = scopePlanFromDto(dto.plan);
	sub.type = getType(dto); // already defined in model
	sub.createdAt = parseDate(dto.created);
	sub.updatedAt = parseDate(dto.updated);
	sub.isPrepaid = dto.type === 'Prepaid';
	sub.isTrial = dto.type === 'Trial';
	sub.isPromo = dto.type === 'Promotion';
	sub.isBasic = dto.type === 'Basic';
	sub.prepaidCouponId = dto.prepaidCouponId;
	sub.prepaidDisplayCode = getDisplayCode(dto.prepaidCouponId);
	sub.expiry = dto.currentPeriodEnd || dto.expiry;
	sub.trialExpiry = dto.trialExpiresOn || dto.trialExpiry;
	sub.isLegacy = dto.plan.id.includes('base');
	sub.transitionAtEnd = dto.transitionAtEnd;
	sub.cancelAtPeriodEnd = dto.cancelAtPeriodEnd;
	sub.renews = getRenewalState(sub);

	sub.maintenancePeriod = dto.maintenancePeriod || {};

	// dont bother unless its prepaid
	if (sub.isPrepaid) {
		sub.isPerpetual = isPerpetualLicense(dto.currentPeriodStart, dto.currentPeriodEnd);
	}

	if (sub.isPerpetual) {
		sub.maintenanceEnds =  dto.maintenancePeriod && dto.maintenancePeriod.expiration;
	}

	return sub;
}

export {
	scopeSubFromDto,
	scopePlanFromDto,
	reducePlans,
	mapSubsToPlans,
	mapFeatures,
	filterPlansByTier,
	createPlansHash
};



// WEBPACK FOOTER //
// ./src/modules/scope-dto.js